import { defineMessages } from 'react-intl';

export const messages: {
	searchAcrossProducts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreAppsCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchAcrossProducts: {
		id: 'search_dialog_search_across_products',
		defaultMessage: 'Search all apps',
		description: 'Label for link to redirect users to search page',
	},
	more: {
		id: 'search_dialog_search_across_products.more',
		defaultMessage: 'more',
		description: 'Label to signify that a user can search for more connected apps',
	},
	moreApps: {
		id: 'search_dialog_search_across_products.more-apps',
		defaultMessage: '+ {more}',
		description:
			'Label showing additional connected apps available with a plus symbol prefix, e.g. "+ more"',
	},
	moreAppsCount: {
		id: 'search_dialog_search_across_products.more-apps-count',
		defaultMessage: '+{count}',
		description: 'Label showing the number of additional apps a user can search across, e.g. "+5"',
	},
});
